
// const baseURL1 = `http://f7f099d1.ngrok.io/api/`;
const baseURL = `http://localhost:3000/api/`;
// const imgsrc = "http://107e3c74.ngrok.io";
export default baseURL;



// WEBPACK FOOTER //
// ./src/config.js